module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/lock-5904cc52967a700b79d08f06b42f6ebd.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/lock.svg
// module id = 9HKt
// module chunks = 24